import { Converter } from "showdown";
import * as SurveyCore from "survey-core";
import { TextMarkdownEvent } from "survey-core/typings/survey-events-api";

const useSurveyJSCKEditor = () => {
  const doMarkdown = (
    _survey: SurveyCore.SurveyModel,
    options: TextMarkdownEvent
  ) => {
    const converter = new Converter();
    // convert the markdown text to html
    let str = converter.makeHtml(options.text);
    if (str.indexOf("<p>") === 0) {
      // remove root paragraphs <p></p>
      str = str.substring(3);
      str = str.substring(0, str.length - 4);
    }
    // set html
    options.html = str;
  };

  return {
    doMarkdown,
  };
};

export default useSurveyJSCKEditor;
